export function percentFilter(value) {
    return value * 100 + '%';
}
